import React from "react";
import { Link } from "react-router-dom";
import "./Home.scss";

export default function Home() {
    return (
            <div className="HomeDiv">
                <div className="brand-accent-glow"></div>
                <div className="main-card">
                    <h1 className="Title">GDGoC 4Cut</h1>
                    <div className="brand-line-container">
                        <div className="line yellow"></div>
                        <div className="line red"></div>
                        <div className="line blue"></div>
                        <div className="line green"></div>
                    </div>
                    <div className="btn_block">
                        <Link to="/camera" className="StartButton">
                            <span>촬영 시작하기</span>
                        </Link>
                    </div>
                    <div className="text-group">
                        <h3 className="kor_subtext">촬영 시작 버튼을 눌러 GDGoC 네컷 촬영을 시작합니다.</h3>
                        <h4 className="eng_subtext">Press the button to start the session.</h4>
                    </div>
                </div>
                <h4 className="credit_text">© 2026 GDGoC 4th Organizer Junseok Yun, Siyeon Han. All rights reserved.</h4>
            </div>
    );
}
